<div *ngIf="text | async as receivedText" [innerHtml]="receivedText"></div>
